package com.devi3east.bashbuddy.common.service

interface AppVersionProvider {
    val buildNumber: Int
    val versionName: String
    val platform: Platform
}

enum class Platform {
    ANDROID,
    IOS,
    WEB,
    DESKTOP
}

expect fun appVersionProvider(): AppVersionProvider